<template>
  <div class="table_form">
    <ul :class="[cls,largeLabelCls]">
      <li v-for="(item,index) of columnData" :key="index" class="column_item">
        <span class="item_lable" :title="item.label">{{item.label}}</span>
        <!--数据可能一对多  多的情况 用数组循环显示 -->
        <span
          class="item_data single_item_single"
          v-if="Object.prototype.toString.call(tableData[item.field]) == '[object String]'"
          :title="tableData[item.field]"
        >{{tableData[item.field] || "-"}}</span>
        <span
          v-else
          v-for="(itemData,j) of tableData[item.field]"
          :key="j"
          :title="itemData"
          class="item_data"
          :style="widthComputed(tableData[item.field])"
        >{{itemData || "-"}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
const paddingWidth = 100 + 40;
export default {
  props: {
    columnData: {
      //列数据
      type: Array,
      default: () => []
    },

    cls: {
      type: String, //控制数据单列显示 还是并列显示单列
      default: "single"
    },

    tableData: {
      //数据
      type: Object,
      default: () => {}
    },

    largeLabelCls: {
      type: String
    }
  },

  data() {
    return {
      width: ""
    };
  },

  methods: {
    widthComputed(arr) {
      // if (!this.width) {
      const BodyWidth = document.body.clientWidth - paddingWidth;
      // console.log("TCL: widthComputed -> BodyWidth", BodyWidth);
      // console.log("TCL: widthComputed -> arr", arr.length);
      const width = (100-30) / arr.length;
      this.width = width;
      // }
      return { width: `${this.width}%` };
      // return { width: `300px` };
    }
  },

  computed: {
    // widthComputed() {
    //   const width =
    //   return {width:``}
    // }
  }
};
</script>

<style scoped>
.column_item {
  display: inline-block;
}
.item_lable {
  font-weight: 600;
  background: #f7f8fa;
}
.column_item span {
  display: inline-block;
  height: 40px;
  line-height: 36px;
  /* width: 200px; */
  width: 30%;
  min-width: 150px !important;

  color: #4e5671;
  border: 1px solid #f3f4f5;
  padding: 0px 20px;
  border-bottom: none;
  border-right: none;

  text-align: center;
}
.table_form {
  overflow-x: auto;
  /* margin: 10px 20px 0px 20px; */
}

ul {
  /* margin: 10px 20px 0px 20px; */
  border-bottom: 1px solid #f3f4f5;
  /* border-right: 1px solid #f3f4f5; */
  min-width: 100%;
}

li {
  white-space: nowrap;
  font-size: 13px;
}

.item_data,
.item_lable {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  vertical-align: bottom; /* overflow 会带来元素塌陷   需要设置vertical-align*/
}

.double li {
  width: 50% !important;
}

.single_item_single {
  width: calc(100% - 30%) !important;
}

.double {
  border-right: 1px solid #f3f4f5;
}

.single li {
  /* border-right: 1px solid #f3f4f5; */
  /* min-width: 100%; */
  width: 100%;
}

/* .largeLabel .column_item .item_lable {
  width: 300px !important;
}
.doublelargeLabel  .column_item .item_lable {
  width: 400px !important;
}
.doublelargeLabel .single_item_single {
  width: calc(100% - 400px) !important;
} */

/* .largeLabel .column_item .item_data {
  width: calc(100% - 300px) !important;
} */
.single .column_item span:last-child {
  border-right: 1px solid #f3f4f5 !important;
}
</style>